module.exports = __webpack_public_path__ + "static/media/optimizacion.c09db9ba.png";